"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("../baseComponents/Button"));

var _index = require("../../index");

var _utils = require("../../utils/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var TodoItem = function TodoItem(props) {
  var _useState = (0, _react.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      extraBtnClass = _useState2[0],
      setExtraBtnClass = _useState2[1];

  function handleMouseHover() {
    setExtraBtnClass("hover");
  }

  function handleMouseLeave() {
    setExtraBtnClass("");
  }

  function handleOnClick(e) {
    //Only those 2 case needs to stop the primary action, otherwise any click should trigger the action
    if (e.target.tagName === "A" || e.target.parentElement.tagName === "A" || e.target.tagName === "BUTTON" && !e.target.className.includes("primaryBtn") || e.target.parentElement.tagName === "BUTTON" && !e.target.parentElement.className.includes("primaryBtn")) {
      return;
    } else {
      e.preventDefault();
      props.action();
    }
  }

  var componentClasses = (0, _classnames["default"])("todoItem-component", props.className, props.theme, props.type, {
    "focused": props.focused
  });
  var btnTheme = "teal";
  if (props.theme === "grey") btnTheme = "purple";
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: componentClasses,
    style: props.style,
    onMouseEnter: handleMouseHover,
    onMouseLeave: handleMouseLeave,
    onClick: handleOnClick
  }, /*#__PURE__*/_react["default"].createElement(_index.FullBar, {
    left: /*#__PURE__*/_react["default"].createElement("div", {
      className: "todoContent"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "topContent"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "title"
    }, /*#__PURE__*/_react["default"].createElement("p", null, props.title)), props.text && /*#__PURE__*/_react["default"].createElement("p", {
      className: "text"
    }, props.text), props.subText && /*#__PURE__*/_react["default"].createElement("p", {
      className: "mice"
    }, props.subText)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "bottomContent"
    }, props.extraLeftContent && /*#__PURE__*/_react["default"].createElement("div", {
      className: "extraLeftContent"
    }, props.extraLeftContent), props.action && props.type === "ext-1" && /*#__PURE__*/_react["default"].createElement("div", {
      className: "buttonContent"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      radius: "square",
      shapeStyle: "stroke",
      text: props.cta,
      colorTheme: btnTheme,
      size: "small",
      className: "".concat(extraBtnClass, " primaryBtn")
    }), props.extraButtonContent && /*#__PURE__*/_react["default"].createElement("div", {
      className: "extraButtonContent"
    }, props.extraButtonContent)))),
    right: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.extraRightContent && /*#__PURE__*/_react["default"].createElement("div", {
      className: "extraRightContent"
    }, props.extraRightContent), props.action && props.type === "default" && /*#__PURE__*/_react["default"].createElement("div", {
      className: "buttonContent"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      radius: "square",
      shapeStyle: "stroke",
      text: props.cta,
      colorTheme: btnTheme,
      size: "small",
      className: "".concat(extraBtnClass, " primaryBtn")
    }), props.extraButtonContent && /*#__PURE__*/_react["default"].createElement("div", {
      className: "extraButtonContent"
    }, props.extraButtonContent)))
  }));
};

TodoItem.propTypes = {
  type: _propTypes["default"].oneOf(["default", "ext-1"]),
  theme: _propTypes["default"].oneOf(['white', 'grey']),
  cta: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  extraLeftContent: _propTypes["default"].any,
  extraRightContent: _propTypes["default"].any,
  action: _propTypes["default"].func,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  text: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  subText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object]),
  focused: _propTypes["default"].bool
};
TodoItem.defaultProps = {
  type: "default",
  theme: "white",
  title: "",
  text: "",
  subText: "",
  cta: "",
  action: null,
  className: "",
  style: {},
  extraLeftContent: null,
  extraRightContent: null,
  extraButtonContent: null,
  focused: false
};
var _default = TodoItem;
exports["default"] = _default;